<template>
  <aside
    class="fixed inset-y-0 z-20 duration-200 flex-shrink-0 h-screen overflow-hidden overflow-y-auto bg-greenSide md:static focus:outline-none"
    :class="[open ? 'w-20' : 'w-0 md:w-48']"
  >
    <nav class="flex flex-col flex-shrink-0 h-full px-3 py-4 border-r">
      <div class="flex flex-col flex-1 space-y-4">
        <navigation-link routeLink="/dashboard">
          <IconHome />
          <span class="text-sm">Dashboard</span>
        </navigation-link>
        <navigation-link routeLink="/maps">
          <IconMaps />
          <span class="text-sm">Maps</span>
        </navigation-link>
        <navigation-link routeLink="/sgn-kso">
          <IconInfo />
          <span class="text-sm">Area Info</span>
        </navigation-link>
        <navigation-link routeLink="/order">
          <IconOrder />
          <span class="text-sm">Order</span>
        </navigation-link>
        <navigation-link routeLink="/post-order">
          <IconPostOrder />
          <span class="text-sm">Post Order</span>
        </navigation-link>
        <navigation-link routeLink="/scene-calendar">
          <IconDate />
          <span class="text-sm">Scene By Date</span>
        </navigation-link>
        <navigation-link routeLink="/order-status">
          <IconTable />
          <span class="text-sm">Order Status</span>
        </navigation-link>
        <navigation-link routeLink="/post-order-status">
          <IconTransfer />
          <span class="text-sm">Post Order Status</span>
        </navigation-link>
        <navigation-link routeLink="/users" v-if="role === 'admin'">
          <IconUser />
          <span class="text-sm">User Management</span>
        </navigation-link>
      </div>
      <div class="flex items-center flex-shrink-0 mt-4">
        <a
          href="#"
          @click="authStore.logout()"
          class="p-2 flex gap-2 w-full text-indigo-400 transition-colors duration-200 rounded-md bg-indigo-50 hover:text-indigo-600 hover:bg-indigo-100 focus:outline-none focus:bg-indigo-100 focus:ring-indigo-800"
        >
          <svg
            class="w-7 h-7"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            />
          </svg>
          <span>Logout</span>
        </a>
      </div>
    </nav>
  </aside>
  <div
    class="fixed inset-y-0 z-10 duration-500 flex-shrink-0 w-full overflow-hidden h-screen bg-primary bg-opacity-30 backdrop-blur-sm border-r md:static focus:outline-none"
    :class="[open ? 'block md:hidden' : 'hidden md:hidden']"
  >
    <a
      href="#"
      @click="openNav"
      class="p-2 text-indigo-400 absolute right-5 top-5 transition-colors duration-200 rounded-md bg-indigo-50 hover:text-indigo-600 hover:bg-indigo-100 focus:outline-none focus:bg-indigo-100 focus:ring-indigo-800"
    >
      <span class="sr-only">close</span>
      <svg
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        class="w-7 h-7"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </a>
  </div>
</template>

<script>
import NavigationLink from "@/components/NavigationLink.vue";
import { useAuthStore, useNavigationStore } from "@/store";
import { storeToRefs } from "pinia";
import { onMounted, ref } from "vue";
import IconMaps from "./icons/IconMaps.vue";
import IconInfo from "./icons/IconInfo.vue";
import IconOrder from "./icons/IconOrder.vue";
import IconPostOrder from "./icons/IconPostOrder.vue";
import IconHome from "./icons/IconHome.vue";
import IconDate from "./icons/IconDate.vue";
import IconUser from "./icons/IconUser.vue";
import IconTable from "./icons/IconTable.vue";
import IconTransfer from "./icons/IconTransfer.vue";

export default {
  name: "NavigationWeb",
  components: {
    NavigationLink,
    IconMaps,
    IconInfo,
    IconOrder,
    IconPostOrder,
    IconHome,
    IconDate,
    IconUser,
    IconTable,
    IconTransfer,
  },
  setup() {
    const authStore = useAuthStore();
    const navigation = useNavigationStore();
    const { open } = storeToRefs(navigation);
    const role = ref("");
    const showMessage = ref(false);
    const showUser = ref(false);

    const openNav = () => {
      navigation.open = !navigation.open;
    };

    onMounted(() => {
      if (authStore.user != null) {
        console.log(authStore.user.role);
        role.value = authStore.user.role;
      }
    });

    const openMessage = () => {
      showMessage.value = !showMessage.value;
    };
    const openUser = () => {
      showUser.value = !showUser.value;
    };

    return {
      authStore,
      openNav,
      open,
      role,
      openMessage,
      openUser,
      showMessage,
      showUser,
    };
  },
};
</script>
<style></style>
